import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/ShipYard/add'
import constant from '../../../constant'
import { toast } from 'react-toastify'
import {  v3_add_shipyard } from '../../../actions/v3/masterData'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_shipyard(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listShipYardMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Add Ship Yard'}
            >
                <Form
                    title={'Add Ship Yard'}
                    onSubmit={onSubmit}
                    buttonName={'Create Ship Yard'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add